<template>
  <div class="crm-main-cont">
    <div>
      <a-form layout="inline">
        <a-form-item label="查询时间范围">
          <a-range-picker v-model="dateTimeRange" @change="dateChange"/>
        </a-form-item>
        <a-space>
          <a-button style="margin-top: 5px;" @click="reset">
            重置
          </a-button>
          <a-button style="margin-top: 5px;" type="primary" @click="init">
            查询
          </a-button>
        </a-space>
      </a-form>
    </div>

    <div style="padding-top: 15px">
      <a-table
          :columns="columns"
          :dataSource="authList"
          bordered
          rowKey="code"
          :pagination="false">

      </a-table>
    </div>
  </div>
</template>

<script>
import {getAuthedEnterpriseStatistics} from "@/api/company/company";
const columns = [
  {
    title: '机构名称',
    dataIndex: 'name',
    key: 'name',
    scopedSlots: {customRender: "name"},
    width: 400,
  },
  {
    title: '授权数',
    dataIndex: 'authCount',
    key: 'authCount',
    scopedSlots: {customRender: "authCount"}
  },
  {
    title: '企业数',
    dataIndex: 'qyCount',
    key: 'qyCount',
    scopedSlots: {customRender: "qyCount"}
  },
];
export default {
  name: "authStatistics",
  computed: {},
  data() {
    return {
      columns,
      value: "",
      dateTimeRange: [],
      authList: [],
      search: {
        startTime: '',
        endTime: '',
      },
    }
  },
  beforeRouteEnter(to, form, next) {
    next(vm => {
      vm.init();
    })
  },
  methods: {
    init() {
      //初始化
      getAuthedEnterpriseStatistics(this.search).then(res=>{
        this.$ajaxAfter(res).then(()=>{
          this.authList = res.data.data.list;
        })
      }).catch(()=>{
         this.$message.error("服务器异常，请稍后再试")
      })
    },
    reset(){
      this.search = {
        startTime: "",
        endTime: ""
      }
      this.dateTimeRange = [];
      this.init();
    },
    dateChange(date,dateString){
      if (dateString.length==2){
        let [startTime,endTime] = dateString;
        this.search = {
          startTime,
          endTime
        }
      }else {
        this.search = {
          startTime: "",
          endTime: "",
        }
      }
    },
  }
}
</script>

<style scoped lang="less">

</style>
